import { MutableRefObject } from "react";

import {
  IdentificationStatusResponse,
  IdentificationStatusResponseKycStatus,
} from "@/services/model";

export const IDENTIFICATION_STATUS_CACHE_TIME_MS = 5 * 60 * 1000;
export const IDENTIFICATION_STATUS_VERIFIED_STALE_TIME_MS = 5 * 60 * 1000;
export const IDENTIFICATION_STATUS_FRAUD_CHECK_POLL_MS = 5_000;

export type IdentificationStatusStaleTimeRef = MutableRefObject<number>;

export const createIdentificationStatusQueryOptions = (
  staleTimeRef: IdentificationStatusStaleTimeRef,
) => ({
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  cacheTime: IDENTIFICATION_STATUS_CACHE_TIME_MS,
  retry: false,
  staleTime: staleTimeRef.current,
  refetchInterval: (data?: IdentificationStatusResponse) =>
    data?.kycStatus ===
    IdentificationStatusResponseKycStatus.FRAUD_CHECK_PENDING
      ? IDENTIFICATION_STATUS_FRAUD_CHECK_POLL_MS
      : false,
  onSuccess: (data?: IdentificationStatusResponse) => {
    if (
      data?.kycStatus === IdentificationStatusResponseKycStatus.OK &&
      data?.isVerified
    ) {
      staleTimeRef.current = IDENTIFICATION_STATUS_VERIFIED_STALE_TIME_MS;
    }
  },
});
